export default __webpack_public_path__ + "static/DF_2017-3f800d8ed17f497a05cc3688aea3578b.pdf";